import Aegis from "aegis-web-sdk";
import { getMySid } from "@mono/bridge";

const mixin = {
  beforeCreate: function beforeCreate() {
    let options = this.$options;
    options.aegis = options.aegis || (options.__aegis ? {} : null);
    if (options.aegis) {
      if (options.aegis instanceof Aegis) {
        this._aegis = options.aegis;
      } else {
        if (process.env.NODE_ENV !== "production") {
          warn("Cannot be interpreted 'aegis' option.");
        }
      }
    } else if (
      this.$root &&
      this.$root.$aegis &&
      this.$root.$aegis instanceof Aegis
    ) {
      this._aegis = this.$root.$aegis;
    } else if (
      options.parent &&
      options.parent.$aegis &&
      options.parent.$aegis instanceof Aegis
    ) {
      // parent aegis
      this._aegis = options.parent.$aegis;
    }
  },
};

const AegisPlugin = {
  install(Vue, options = {}) {
    if (!Vue.prototype.hasOwnProperty("$aegis")) {
      // $FlowFixMe
      Object.defineProperty(Vue.prototype, "$aegis", {
        get: function get() {
          return this._aegis;
        },
      });
    }
    Vue.mixin(mixin);
    // use simple mergeStrategies to prevent aegis instance lose '__proto__'
    var strats = Vue.config.optionMergeStrategies;
    strats.aegis = function (parentVal, childVal) {
      return childVal === undefined ? parentVal : childVal;
    };
  },
};

Vue.use(AegisPlugin);

export const aegisInit = async (
  reportApiSpeed = false,
  reportAssetSpeed = false,
  webVitals = false,
  pagePerformance = true
) => {
  const sid = await getMySid();
  const pageUrl = window.location.href.replace(/\?/g, "_");
  const aegis = new Aegis({
    id: "EPDYVcrVV2EDbEwKRv", // 上报 id
    uin: `${sid}`, // 用户唯一ID
    reportApiSpeed: reportApiSpeed, // 接口测速
    reportAssetSpeed: reportAssetSpeed, // 静态资源测速
    pagePerformance: pagePerformance, // 页面性能
    webVitals: webVitals,
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
    hostUrl: "https://rumt-sg.com",
    pageUrl: pageUrl,
    version: process.env.PACKAGE_VERSION,
    repeat: 3, // 重复上报次数
    env:
      process.env.NODE_ENV == "development"
        ? Aegis.environment.development
        : Aegis.environment.production,
  });
  Vue.config.errorHandler = function (err, vm, info) {
    console.log(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
    aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
  };
  return aegis;
};
